<template>
  <div id="project-form">
    <form @submit.prevent="submit">
      <section>
        <b-field label="Name">
          <b-input v-model="form.name" />
        </b-field>
      </section>
      <input class="button" type="submit" value="Save" />
      <router-link class="button submit" to="/payment_methods">Back</router-link>
    </form>
  </div>
</template>

<script>
import http from '@/lib/utils/http'
import { error, success } from '@/lib/utils/toast'

export default {
  props: ['id'],
  data() {
    return {
      form: {
        name: '',
      },
      errors: {},
    }
  },
  methods: {
    loadPaymentMethod(paymentMethodId) {
      const loader = this.$loading.open()

      http
        .get('payment_methods/' + paymentMethodId)
        .then(resp => {
          const paymentMethod = resp.data
          this.form.name = paymentMethod.name
        })
        .catch(() => {})
        .then(() => {
          loader.close()
        })
    },
    submit() {
      const body = this.form
      const request = this.id
        ? http.put('payment_methods/' + this.id, body)
        : http.post('payment_methods', body)

      request
        .then(() => {
          this.$toast.open(success())
        })
        .catch(errors => {
          this.errors = errors.response.data
          this.$toast.open(error())
        })
    },
  },
  created() {
    this.loadPaymentMethod(this.id)
  },
}
</script>

<style>
.file-name {
    border-color: #dbdbdb;
    border-style: solid;
    border-width: 1px 1px 1px 0;
    display: block;
    max-width: 16em;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentMethods/Form.vue